declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_simple_default_indexed_foo extends $mol_object {
		a_b( id: any, next?: number ): number
		legacy( id: any, next?: number ): number
	}
	
}

//# sourceMappingURL=simple_default_indexed.view.tree.d.ts.map